module.exports = __webpack_public_path__ + "img/logo.ccba4e1a.svg";